import { injector } from 'base/dependency-container';
import { PreferencesStore } from 'base/preferences_store';
import { createAccountService } from './account';

export function createPreferenceService() {
  const { service } = injector.resolve(createAccountService);
  return new PreferencesStore(service);
}
